import { c as _c } from "react/compiler-runtime";
import { classNames, AuthCode as UIKitAuthCode } from "@opensea/ui-kit";
export const AuthCode = props => {
  const $ = _c(14);
  const t0 = props.overrides?.Inputs?.className;
  let t1;
  if ($[0] !== t0) {
    t1 = classNames("!size-12 gap-[7px] bg-bg-primary shadow-sm sm:!size-14", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      className: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.overrides?.Container?.className;
  let t4;
  if ($[4] !== t3) {
    t4 = classNames("justify-center gap-2", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      className: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = {
      Inputs: t2,
      Container: t5
    };
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props || $[12] !== t6) {
    t7 = <UIKitAuthCode {...props} overrides={t6} />;
    $[11] = props;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};